import React from 'react';
import { Desktop } from './components/Desktop';
import { TutorialWalkthrough } from './components/tutorial/TutorialWalkthrough';
import { SimulationProvider } from './context/SimulationContext';

export default function App(): React.ReactElement {
  const rawScenario = new URLSearchParams(window.location.search).get(
    'scenario'
  );
  const scenarioParam =
    !rawScenario || rawScenario === 'demo' ? 'demo' : rawScenario;
  const showTutorial = scenarioParam === 'demo';

  return (
    <SimulationProvider scenarioParam={scenarioParam}>
      <Desktop />
      {showTutorial ? <TutorialWalkthrough /> : null}
    </SimulationProvider>
  );
}
